<div class="u-paddingTop-32">
  <nz-breadcrumb>
    <nz-breadcrumb-item>
      <a
        [routerLink]="['/admin/members']"
        class="color-grey-300 u-cursor-pointer text-body-2"
        i18n="@@global.manageMembers"
        >Manage members</a
      >
    </nz-breadcrumb-item>
    <nz-breadcrumb-item i18n="@@csvImport.breadCrumbs.uploadMembershipFile"
      >Upload membership file</nz-breadcrumb-item
    >
    <nz-breadcrumb-item *ngIf="file">{{ file.name }}</nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-steps
    [nzCurrent]="getCurrentStepIndex()"
    class="u-padding-16-0"
    nzSize="small"
  >
    <nz-step
      nzTitle="Upload file"
      i18n-nzTitle="@@csvImport.steps.uploadFile"
    ></nz-step>
    <nz-step
      nzTitle="Review mappings"
      i18n-nzTitle="@@csvImport.steps.reviewMapping"
    ></nz-step>
    <nz-step
      nzTitle="Approve member updates"
      i18n-nzTitle="@@csvImport.steps.approveMemberUpdates"
    ></nz-step>
  </nz-steps>
  @if (associatedWithActionQueueGroupData && uploadedFlatFileName) {
    <app-automated-user-management-banner
      [buttonText]="automatedUserManagementBannerText.buttonText"
      [description]="automatedUserManagementBannerText.description"
      [imageName]="automatedUserManagementBannerText.imageName"
      [title]="automatedUserManagementBannerText.title"
      (action)="navigateToActionQueues()"
    >
    </app-automated-user-management-banner>
  }
</div>
@switch (viewMode) {
  @case (viewModes.import_file) {
    <ol fxLayout="column" fxLayoutGap="16px">
      <div
        class="bg-color-white u-card u-padding-16 mat-elevation-z1"
        fxLayout="column"
        fxLayoutGap="8px"
      >
        <li class="u-marginLeft-16">
          <p class="text-body-1" i18n="@@csvImport.blockOne.title">
            Prepare membership file
          </p>
        </li>
        <ng-container>
          <p
            class="u-text-maxWidth color-grey-300 text-body-2"
            i18n="@@csvImport.block.subTitle"
          >
            Export a spreadsheet of members from your HRIS, Member Directory, or
            CRM platform.
          </p>
          <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="8px">
            <a
              appZendeskLink
              class="color-teal-700"
              href="https://support.tenthousandcoffees.com/hc/articles/20332818989332"
              i18n="@@csvImport.viewImportGuide"
              >View import guide</a
            >
            <mat-divider
              [ngStyle]="{
                height: '20px',
              }"
              vertical
            ></mat-divider>
            <a
              class="color-teal-700"
              href="https://docs.google.com/spreadsheets/d/1fslLYp0fwU_rw_hwYfR7TNMhd6N30Bc0mlrbh4ZmUo0/edit#gid=0"
              i18n="@@csvImport.viewSampleSpreadSheet"
              >Download example membership file</a
            >
          </div>
        </ng-container>
      </div>
      <div
        class="bg-color-white u-card u-padding-16 mat-elevation-z1"
        fxLayout="column"
        fxLayoutGap="16px"
      >
        <li class="u-marginLeft-16">
          <p class="text-body-1" i18n="@@csvImport.blockTwo.title">
            Choose a Hub to update member data
          </p>
        </li>
        <nz-select
          [ngStyle]="{ width: '273px' }"
          [(ngModel)]="selectedGroup"
          (ngModelChange)="onGroupChange($event)"
          nzAllowClear
          nzPlaceHolder="Choose a hub"
          nzShowSearch
          i18n-nzPlaceHolder="@@csvImport.select.chooseHubPlaceHolder"
        >
          <nz-option
            *ngFor="let group of groups"
            [nzLabel]="group.name"
            [nzValue]="group"
          ></nz-option>
        </nz-select>
      </div>
      <div
        class="bg-color-white u-card u-padding-16 mat-elevation-z1"
        fxLayout="column"
        fxLayoutGap="16px"
      >
        <li class="u-marginLeft-16">
          <p class="text-body-1" i18n="@@csvImport.blockThree.title">
            Upload CSV with member data
          </p>
        </li>
        <div fxLayout="row" fxLayoutAlign="start center">
          <input
            #fileInput
            [ngStyle]="{ display: 'none' }"
            (change)="onAfterAddingFile($event)"
            accept=".csv"
            type="file"
          />
          <button
            (click)="openFileInput()"
            color="accent"
            mat-stroked-button
            i18n="@@csvImport.button.importFile"
          >
            Browse for file
          </button>
          <div *ngIf="file" fxLayout="row" fxLayoutAlign="start center">
            <button (click)="removeUploadedFile()" mat-icon-button>
              <mat-icon class="color-grey-300">cancel</mat-icon>
            </button>
            <p>
              {{ file.name }}
            </p>
          </div>
        </div>
        <div>
          <button
            [disabled]="!file || !selectedGroup"
            [ngStyle.lt-sm]="{ width: '100%' }"
            (click)="parseCsvFile()"
            color="primary"
            mat-raised-button
          >
            <span i18n="@@csvImport.button.uploadFile">
              Upload and import file</span
            >
            <i
              *ngIf="isLoading"
              class="u-marginLeft-8"
              nz-icon
              nzSpin
              nzTheme="outline"
              nzType="sync"
            ></i>
          </button>
        </div>
      </div>
    </ol>
  }
  @case (viewModes.upload_file) {
    <div class="u-verticalAlign-middle bg-color-white u-card u-padding-24-0">
      @if (isLoading) {
        <app-progress-spinner class="u-marginTop-16" size="large">
        </app-progress-spinner>
      }
      <h6
        class="u-textAlign-center u-marginTop-16"
        i18n="@@csvImport.loader.text"
      >
        Uploading your CSV
      </h6>
    </div>
  }
  @case (viewModes.attribute_mapping) {
    <div
      class="u-verticalAlign-middle u-padding-16-0"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <app-csv-attribute-mappings
        [group]="selectedGroup"
        [tenant]="tenant | async"
        [uploadedData]="parsedData"
        (viewChange)="uploadCsvFile($event)"
        class="u-display-block"
      ></app-csv-attribute-mappings>
    </div>
  }
  @case (viewModes.upload_completed) {
    <div
      class="u-verticalAlign-middle bg-color-white u-card u-padding-16-0"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img
        [ngStyle]="{ 'max-width': '125px' }"
        alt="Illustration of the state uploaded CSV file"
        src="//storage.googleapis.com/ttc-static-images/Empty%20State%20Illustrations/Success.B84A052.png"
        i18n-alt="@@csvImport.alt.completedUploadCsvFileIllustration"
      />
      <h6
        class="u-textAlign-center u-marginTop-16"
        i18n="@@csvImport.importCompleted.title"
      >
        Import completed
      </h6>
      <p
        class="u-marginTop-8 text-body-2"
        i18n="@@csvImport.importCompleted.subTitle"
      >
        Your CSV will be processed and sent to you via email.
      </p>
    </div>
  }
  @case (viewModes.upload_failed) {
    <div
      class="u-verticalAlign-middle bg-color-white u-card u-padding-16-0"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img
        [ngStyle]="{ 'max-width': '125px' }"
        alt="Illustration of a CSV file that has failed to upload"
        src="//storage.googleapis.com/ttc-static-images/Empty%20State%20Illustrations/No%20User.0B48472.png"
        i18n-alt="@@csvImport.alt.failedUploadCsvFileIllustration"
      />
      <h6
        class="u-textAlign-center u-marginTop-16"
        i18n="@@csvImport.importFailed.title"
      >
        File cannot be imported
      </h6>
      <p
        class="u-marginTop-8 text-body-2"
        i18n="@@csvImport.importFailed.subTitle"
      >
        Your file cannot be imported. Try importing again, or
        <a (click)="helpCenterClicked()" class="color-blue"
          >contact 10KC Support</a
        >
        for help.
      </p>
      <a (click)="restartUpload()" class="u-marginTop-16" mat-stroked-button>
        <span class="color-blue" i18n="@@csvImport.button.restartUpload"
          >Restart upload</span
        >
      </a>
    </div>
  }
}
